export default {
  'h5listceshi': 'H5列表测试'
}